import { Moment } from 'moment';
import { ICell } from './cell';
import { IOperator } from './operator';
import { ITechnician } from './technician';
import { ISector } from './sector';
import { IUser } from './user';
import { IPatrimony } from './patrimony';

export interface IFilterTask {
  orderBy: 'id' | 'stage' | 'urgencyDegree' | 'status';
  orderDirection: 'ASC' | 'DESC';
  sectorId?: number;
  stage?: number;
  /** 0 = CORRECTIVE, 1 = PREVENTIVE; omit for all */
  maintenanceType?: number;
}

export enum TaskUrgencyDegree {
  LOW = 0,
  HIGH = 1,
  VERY_HIGH = 2,
  CRITICAL = 3,
  NONE = 4,
}

export enum TaskStatus {
  APPROVED = 0,
  REVIEWING = 1,
  REJECTED = 2,
}

export enum TaskStage {
  TODO = 0,
  DOING = 1,
  VALIDATING = 2,
  DONE = 3,
  ICEBODX = 4,
  PREVENTIVE_SCHEDULED = 5,
}

export enum TaskMaintenanceType {
  CORRECTIVE = 0,
  PREVENTIVE = 1,
}

export interface ITaskChecklistItem {
  id: number;
  machineRepairTaskId: number;
  title: string;
  description?: string | null;
  position: number;
  required: boolean;
  completed: boolean;
  notes?: string | null;
  completedAt?: string | null;
  completedByUsuarioId?: number | null;
}

export interface ITask {
  id: number;
  description: string;
  technical_advice?: string;
  status: TaskStatus;
  stage: TaskStage;
  urgencyDegree: TaskUrgencyDegree;
  maintenanceType: TaskMaintenanceType;
  patrimonyId: number;
  occurredAt: string;
  finishedAt?: string;
  deletedAt?: null;
  createdAt: string;
  updatedAt: string;
  sector: ISector;
  user: IUser;
  patrimony: IPatrimony;
  technicianTasks: {
    id: number;
    principal: boolean;
    technicianId: number;
    taskId: number;
    technician: ITechnician | null;
  }[];
  checklistItems?: ITaskChecklistItem[];
  cellId: number | null;
  cell: ICell | null;
  operatorId: number | null;
  operator: IOperator | null;
  historyAudits?: [any];
}

export interface ICreateTaskInput {
  description?: string;
  stage?: TaskStage;
  urgencyDegree?: any;
  occurredAt?: Moment;
  userId?: number;
  finishedAt?: string;
  patrimonyId?: number;
  operatorId?: number;
  cellId?: number;
  status?: TaskStatus;
  technicians?: [
    {
      id: number;
      principal: boolean;
    }
  ];
}

export interface IUpdateTaskInput {
  description?: string;
  stage?: TaskStage;
  urgencyDegree?: TaskUrgencyDegree;
  occurredAt?: Moment;
  userId?: number;
  finishedAt?: string;
  patrimonyId?: number;
  operatorId?: number;
  cellId?: number;
  status?: TaskStatus;
  technicians?: [
    {
      id: number;
      principal: boolean;
    }
  ];
}

export interface IUpdateChecklistItemsInput {
  items: {
    id: number;
    completed: boolean;
    notes?: string;
  }[];
}

